import React, { useEffect, useState } from "react";
import axios from "axios";
import { SubmitForm } from "./SubmitForm";
import { Docket } from "./Docket";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SubmitSection = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/submissions?status=pending`).then((r) => setItems(r.data)).catch((e) => console.error(e));
  }, []);

  return (
    <section id="submit" className="py-20 relative bg-[#0b0b0b] brutal-border-y" data-testid="submit-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <header className="mb-12 flex items-end justify-between flex-wrap gap-4">
          <div>
            <span className="font-mono text-xs uppercase text-[#00FF00]">Chapter 04 · Citizen Reports</span>
            <h2 className="heading text-5xl md:text-7xl leading-[0.9] mt-2">
              SEEN SOMETHING? <br />
              <span className="bg-[#00FF00] text-black px-2">SNITCH</span> SOMETHING.
            </h2>
          </div>
          <p className="max-w-sm text-sm text-white/70">
            File a report. Five witnesses second it, it graduates to the Timeline. Lies get laughed out of court.
          </p>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-7">
            <SubmitForm onSubmitted={(s) => setItems((xs) => [s, ...xs])} />
          </div>
          <div className="lg:col-span-5">
            <Docket items={items} setItems={setItems} />
          </div>
        </div>
      </div>
    </section>
  );
};
